export class UsrUser{
    usrId: number;
    usrEmail: string;
    usrType: number;
    usrPassword: string;
    usrEnable: boolean;
    usrLastLogin?: any;
}